import { render, staticRenderFns } from "./PatternUserMenu.vue?vue&type=template&id=63667377&"
import script from "./PatternUserMenu.vue?vue&type=script&lang=js&"
export * from "./PatternUserMenu.vue?vue&type=script&lang=js&"
import style0 from "./PatternUserMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports